import {ActionTree} from "vuex";
import {DataImplementationState, DataImplementation, Message} from "./model";
import {RootStateType} from "@/store";
import {AxiosResponse} from "axios";
import {DataPropertyImplementation} from "@/store/modules/hcs/dataPropertyImplementation/model";

const actions: ActionTree<DataImplementationState, RootStateType> = {
  findList({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].get('/data_implementations', {params: params})
        .then((response: AxiosResponse) => {
          const dataImplementations: DataImplementation[] = response.data;
          commit('setDataImplementations', dataImplementations);
          return dataImplementations;
        });
  },
  find({rootGetters, commit}, id) {
    return rootGetters['hcs/client'].get(`/data_implementations/${id}`)
        .then((response: AxiosResponse) => {
          const dataImplementation: DataImplementation = response.data;
          commit('setDataImplementation', dataImplementation);
          return dataImplementation;
        });
  },
  create({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].post('/data_implementations', params)
        .then((response: AxiosResponse) => {
          const dataImplementation: DataImplementation = response.data;
          commit('replaceDataImplementation', dataImplementation);
          return dataImplementation;
        });
  },
  update({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].patch(`/data_implementations/${params.id}`, params)
        .then((response: AxiosResponse) => {
          const dataImplementation: DataImplementation = response.data;
          commit('updateDataImplementation', dataImplementation);
          return dataImplementation
        });
  },
  delete({rootGetters, commit}, id) {
    return rootGetters['hcs/client'].delete(`/data_implementations/${id}`)
        .then((response: AxiosResponse) => {
          commit('deleteDataImplementation', id);
        });
  },
  findDataPropertyImplementationList({rootGetters, commit}, id) {
    return rootGetters['hcs/client'].get(`/data_implementations/${id}/data_property_implementations`)
        .then((response: AxiosResponse) => {
          const dataPropertyImplementations: DataPropertyImplementation[] = response.data;
          commit('hcs/dataPropertyImplementation/setDataPropertyImplementations', dataPropertyImplementations, {root: true});
          return dataPropertyImplementations
        });
  },
  findMessageList({rootGetters, commit}, {id, page, perPage}) {
    return rootGetters['hcs/client'].get(`/data_implementations/${id}/messages`, {params: { page, perPage }})
        .then((response: AxiosResponse) => {
          const messages: Message[] = response.data;
          commit('setMessages', messages);
          return {
            messages,
            page: parseInt(response.headers['x-page'], 10),
            perPage: parseInt(response.headers['x-per-page'], 10),
            total: parseInt(response.headers['x-total'], 10),
          }
        });
  },
  requestSampleData({rootGetters}, id) {
    return rootGetters['hcs/client'].post(`/data_implementations/${id}/request_sample_data`)
  }
}

export default actions;
